export function decodeJwt(token: string): {header: Record<string, unknown>; payload: Record<string, unknown>; signature: string} {
    const base64UrlDecode = (input: string): string => {
        let b = input.replace(/-/g, '+').replace(/_/g, '/');
        switch (b.length % 4) {
            case 0:
                break;
            case 2:
                b += '==';
                break;
            case 3:
                b += '=';
                break;
            default:
                throw new Error('Illegal base64url string');
        }
        const bytes = Uint8Array.from(window.atob(b), c => c.charCodeAt(0));
        return new TextDecoder().decode(bytes);
    };

    const segments = token.split('.');
    if (segments.length !== 3) {
        throw new Error('Not a JWT');
    }

    return {
        header: JSON.parse(base64UrlDecode(segments[0])),
        payload: JSON.parse(base64UrlDecode(segments[1])),
        signature: segments[2]
    };
}
